var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"loading","appear":""}},[_c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"box-wrapper"},[_c('div',{staticClass:"box"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')]),_vm._v(" "),_c('p',[_vm._v("加载中...")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }